import { cn } from "@/lib/utils";

export function LoadingState({ className }: { className?: string }) {
  return (
    <div
      role="status"
      className={cn("flex min-h-0 flex-1 items-center justify-center p-8 text-sm text-muted-foreground", className)}
    >
      Loading…
    </div>
  );
}
